import { Alert } from "@omni/ui/components/Alert/alert.component";
import { cn } from "@omni/utils/styles";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";

export type ProductFacingProps = {
    layer: string;
    subFacingName: string;
    name: string;
    position: string;
    amountOfPositions: string;
    className?: string;
};

const ProductFacing = ({
    layer,
    subFacingName,
    name,
    position,
    amountOfPositions,
    className
}: ProductFacingProps) => {
    const { t } = useGranite();

    return (
        <Alert
            color={"info"}
            closeAriaLabel={t("general.alert.close")}
            className={cn("tw:flex tw:gap-2 tw:items-center", className)}
        >
            <i className={cn("las la-info", "tw:text-2xl tw:block")} />
            <span className={cn("tw:block")}>
                {`${layer} - ${subFacingName} (${name} ${position}/${amountOfPositions})`}
            </span>
        </Alert>
    );
};

export { ProductFacing };
